import HeroBanner from './hero-banner';

export default HeroBanner;
